import React from "react";
import PenguinGame from "../components/PenguinGame";
import Meta from "./../components/Meta";

function NotFoundPage(props) {
  return (
    <>
      <Meta title="404" />
      <div
        style={{
          padding: "50px",
          width: "100%",
          textAlign: "center",
        }}
      >
        The page <code>{props.location.pathname}</code> could not be found
        <PenguinGame size={8} numFish={Math.floor(Math.random() * 21)} />
      </div>
    </>
  );
}

export default NotFoundPage;
